import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { Send, Square } from 'lucide-react';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
export function ChatInput({ onSend, onCancel, isStreaming }) {
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const textareaRef = useRef(null);
    const resize = useCallback(() => {
        const el = textareaRef.current;
        if (!el)
            return;
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 120) + 'px';
    }, []);
    const handleSend = useCallback(() => {
        const trimmed = value.trim();
        if (!trimmed || isStreaming)
            return;
        onSend(trimmed);
        setValue('');
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
        }
    }, [value, isStreaming, onSend]);
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    }, [handleSend]);
    return (
    // Bottom of a panel pinned to the screen's bottom edge: clear the home
    // indicator (env() is 0 where there is none).
    _jsx("div", { className: "border-border bg-panel-chrome border-t px-3 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]", children: _jsxs("div", { className: "flex items-end gap-2", children: [_jsx("textarea", { ref: textareaRef, value: value, onChange: (e) => {
                        setValue(e.target.value);
                        resize();
                    }, onKeyDown: handleKeyDown, placeholder: t('chat.askPlaceholder'), "aria-label": t('chat.askPlaceholder'), 
                    // Return sends (Shift+Return for a newline), so label the key that way.
                    enterKeyHint: "send", rows: 1, className: "border-border bg-background text-foreground placeholder:text-muted-foreground focus:ring-accent-ai max-h-[120px] min-h-[36px] flex-1 resize-none rounded-lg border px-3 py-2 text-sm focus:ring-1 focus:outline-none" }), isStreaming ? (_jsx("button", { type: "button", onClick: onCancel, className: cn('flex h-9 w-9 shrink-0 items-center justify-center rounded-lg', 'bg-destructive/10 text-destructive hover:bg-destructive/20 transition-colors'), title: t('chat.stopGenerating'), "aria-label": t('chat.stopGenerating'), children: _jsx(Square, { className: "h-4 w-4" }) })) : (_jsx("button", { type: "button", onClick: handleSend, disabled: !value.trim(), "aria-label": t('chat.sendMessage'), className: cn('flex h-9 w-9 shrink-0 items-center justify-center rounded-lg transition-colors', value.trim()
                        ? 'bg-accent-ai/15 text-accent-ai hover:bg-accent-ai/25'
                        : 'text-muted-foreground/40'), title: t('chat.sendMessage'), children: _jsx(Send, { className: "h-4 w-4" }) }))] }) }));
}
